const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000/api";

/**
 * Fetches all collections from the database
 * @returns {Promise<Array<string>>} Array with collection names
 */
export const getCollections = async () => {
    try {
        const response = await fetch(`${API_URL}/collections`);
        if (!response.ok) {
            throw new Error(`Error fetching collections: ${response.status}`);
        }
        const data = await response.json();
        return data.collections || [];
    } catch (error) {
        console.error("Error in getCollections:", error);
        throw error;
    }
};

/**
 * Fetches messages/documents from a specific collection with pagination
 * @param {string} collectionName - Name of the collection
 * @param {number} page - Page number (default: 1)
 * @param {number} limit - Limit of documents to fetch (default: 100)
 * @returns {Promise<Object>} Object with pagination metadata and documents
 */
export const getCollectionMessages = async (
    collectionName,
    page = 1,
    limit = 100,
) => {
    try {
        const response = await fetch(
            `${API_URL}/collections/${encodeURIComponent(
                collectionName,
            )}/messages?page=${page}&limit=${limit}`,
        );
        if (!response.ok) {
            throw new Error(`Error fetching messages: ${response.status}`);
        }
        const data = await response.json();
        return {
            documents: data.documents || [],
            page: data.page,
            totalPages: data.totalPages,
            totalCount: data.totalCount,
            count: data.count,
        };
    } catch (error) {
        console.error(
            `Error in getCollectionMessages for ${collectionName}:`,
            error,
        );
        throw error;
    }
};

/**
 * Search messages/documents in a specific collection
 * @param {string} collectionName - Name of the collection
 * @param {string} searchQuery - Search query string
 * @param {number} page - Page number (default: 1)
 * @param {number} limit - Limit of documents to fetch (default: 100)
 * @returns {Promise<Object>} Object with pagination metadata and documents
 */
export const searchCollectionMessages = async (
    collectionName,
    searchQuery,
    page = 1,
    limit = 100,
) => {
    try {
        const response = await fetch(
            `${API_URL}/collections/${encodeURIComponent(
                collectionName,
            )}/search?q=${encodeURIComponent(searchQuery)}&page=${page}&limit=${limit}`,
        );
        if (!response.ok) {
            throw new Error(`Error searching messages: ${response.status}`);
        }
        const data = await response.json();
        return {
            documents: data.documents || [],
            page: data.page,
            totalPages: data.totalPages,
            totalCount: data.totalCount,
            count: data.count,
            searchQuery: data.searchQuery,
        };
    } catch (error) {
        console.error(
            `Error in searchCollectionMessages for ${collectionName}:`,
            error,
        );
        throw error;
    }
};
